/*
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
*/
import Presenter from './base';

// This presenter class is used for forms and form versions (primary, draft, and
// archived).

const props = [
  // Numeric id
  'id',
  'projectId',
  'xmlFormId',
  'name',
  'version',
  'keyId',
  'sha256',
  // Form and form draft, not form version
  'enketoId',
  // Form only, not form draft or form version
  'enketoOnceId',
  'state',
  'publishedAt',
  'createdAt',
  'updatedAt',
  'deletedAt',
  // Extended form, extended form version, and extended form draft
  'excelContentType',
  // Extended form and extended form draft
  'submissions',
  'lastSubmission',
  'reviewStates',
  'createdBy',
  // Extended form version
  'publishedBy',
  // Form draft
  'draftToken'
];

export default class Form extends Presenter.define(props) {
  nameOrId() { return this.name != null ? this.name : this.xmlFormId; }

  updatedOrCreatedAt() {
    return this.updatedAt != null ? this.updatedAt : this.createdAt;
  }
}
